import { createI18n } from "vue-i18n";
import indexEN from "@/assets/languages/en/indexEN";
import indexPL from "@/assets/languages/pl/indexPL";

const messages = {
  pl: indexPL,
  en: indexEN,
};

const i18n = createI18n({
  locale: "pl",
  fallbackLocale: "en",
  messages,
  legacy: false,
});

export default i18n;
